"use strict";

var _interopRequireDefault = require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _excluded = ["parse", "className", "maxLength", "onChange", "options"];
var _jsxFileName = "/Users/john/Desktop/Projects/nq-component/src/InputNumber/index.js";
var noop = function noop() {};
var defaultProps = {
  type: 'tel',
  parse: true,
  onChange: noop
};
function InputNumber(_ref) {
  var parse = _ref.parse,
    className = _ref.className,
    maxLength = _ref.maxLength,
    onChange = _ref.onChange,
    options = _ref.options,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  function onInput(e) {
    var value = e.target.value.replace(/[^\d]/gi, ''); // digit only
    e.target.value = value;
    if (maxLength && parseInt(maxLength) < value.length) {
      e.target.value = value.slice(0, parseInt(maxLength));
      return;
    }
    onChange(parse ? parseInt(value) : value);
  }
  return /*#__PURE__*/_react["default"].createElement("input", Object.assign({
    className: (0, _classNames["default"])('form-control', className),
    onInput: onInput
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 9
    }
  }));
}
InputNumber.defaultProps = defaultProps;
var _default = exports["default"] = InputNumber;